import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconInstagram = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect fill="none" height="18" rx="5" strokeWidth="2" width="18" x="3" y="3" />
        <circle cx="12" cy="12" fill="none" r="4" strokeWidth="2" />
      </svg>
    </SvgIcon>
  );
};

export default IconInstagram;
